import { Link } from "react-router-dom";
import { characterList } from "@/mocks/characters";
import type { CharacterItem } from "@/types/content";

export default function CharacterSection() {
  const items = (characterList as CharacterItem[]).slice(0, 4);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/detail/character/${item.id}`}
          className="group relative block rounded-lg overflow-hidden border border-background-200 cursor-pointer"
        >
          <div className="relative w-full aspect-[3/4]">
            <img
              src={item.image}
              alt={item.name}
              title={`${item.name} - 香蕉动漫`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
              <span className="inline-block rounded-full bg-accent-500/90 px-2 py-0.5 text-[10px] font-bold text-white mb-1.5">
                {item.gender}
              </span>
              <h3 className="font-display font-bold text-base md:text-lg text-white leading-tight">
                {item.name}
              </h3>
              <p className="mt-0.5 text-xs text-white/80 line-clamp-1">《{item.work}》</p>
              <p className="mt-2 text-xs text-white/75 line-clamp-2 hidden sm:block">
                {item.intro}
              </p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}